import {FieldArray, FormikValues} from 'formik'
import _ from 'lodash'
import FormMessage from '../../common/messages/FormMessage'
import FormikForm from '../../form/FormikForm'
import FormInput from '../../form/FormInput'
import {useSelector, useDispatch} from 'react-redux'
import {
  BooleanApiData,
  AdminProductDTO,
  UpdateProductPriceRequest,
  AdminProductPrice,
} from '../../../api/data-contracts'
import {Api_Admin_UpsertProductPrices} from '../../../apiClient/apiClient'
import {getAdminState} from '../../../redux/adminSlice'
import {postRequestAsync} from '../../../redux/commonSlice'
import {FormStatus} from '../../../types/FormStatus'
import * as Yup from 'yup'
import {defterdar_log} from '../../../utils/utilities'
import CustomDropdown, {DropdownOption} from '../../form/dropdown/CustomDropdown'
import {useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

const MALI_MUSAVIR_ROLE_ID = 2
const MALI_MUSAVIR_OPTION_VALUE = -2

function AdminProductPricesForm(props: {product?: AdminProductDTO | null}) {
  const adminState = useSelector(getAdminState)

  const [selectedServiceProviderId, setSelectedServiceProviderId] = useState(0)

  const schema = Yup.object({})

  const dispatch = useDispatch()

  const initData: UpdateProductPriceRequest = {
    prices: props.product?.prices,
  }

  const submit = async (values: UpdateProductPriceRequest, actions: FormikValues) => {
    actions.setStatus()
    values.id = props.product?.id
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_UpsertProductPrices,
        body: values,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        if (response.data === true) {
          actions.setStatus(new FormStatus(true, 'Ürün Kaydedildi.'))
        } else {
          actions.setStatus(new FormStatus(false, response.serverMessage))
        }
      })
  }

  function generatePriceForServiceProvider(serviceProviderId: number): AdminProductPrice {
    const financialAdvisorUserId =
      adminState.productsPage?.serviceProviders?.find((m) => m.id === serviceProviderId)?.userId ??
      0

    const name = adminState.productsPage?.serviceProviders?.find(
      (m) => m.id === serviceProviderId
    )?.description

    return {
      financialAdvisorUserId: financialAdvisorUserId,
      financialAdvisorUser: name,
      serviceProviderShares: [
        {
          serviceProviderId: 6,
          serviceProvider: 'Defterdar',
          serviceProviderRole: '',
          serviceProviderRoleId: 0,
          totalPrice: 0,
          totalPriceWithoutTax: 0,
        },
      ],
    }
  }

  function createEmptyShare() {
    return {
      serviceProviderId: 0,
      serviceProvider: '',
      serviceProviderRole: '',
      serviceProviderRoleId: 0,
      totalPrice: 0,
      totalPriceWithoutTax: 0,
    }
  }

  return (
    <FormikForm
      initialValues={initData}
      onSubmit={submit}
      validationSchema={schema}
      enableReinitialize={true}
      formId='admin-product-prices-form'
    >
      {(form_props) => {
        return (
          <>
            <div className='row'>
              <div className='d-flex flex-column mb-7 fv-row col-xl-12'>
                <FieldArray
                  name='prices'
                  render={(arrayHelpers) => (
                    <div className='d-flex flex-column justify-content-center'>
                      <div className='row'>
                        {form_props.values?.prices?.map((price, index) => (
                          <div className='col-xl-12 px-2 pb-5' key={index}>
                            <div className='card card-dashed p-6 position-relative'>
                              {(price.financialAdvisorUserId ?? 0) > 0 && (
                                <button
                                  type='button'
                                  className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary position-absolute top-0 end-0 m-2'
                                  data-kt-menu-trigger='click'
                                  data-kt-menu-placement='bottom-end'
                                  data-kt-menu-flip='top-end'
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/abstract/abs012.svg'
                                    className='svg-icon-muted svg-icon-2hx'
                                  />
                                </button>
                              )}
                              <div className='row mb-2'>
                                <div className='col-xl-3 fw-bold fs-6 text-left'>
                                  {price.financialAdvisorUserId
                                    ? price.financialAdvisorUser + ' İçin Fiyatlar'
                                    : 'Varsayılan Fiyatlar'}
                                </div>
                                <div className='col-xl-1 fw-bold fs-6 text-left'>KDV'siz</div>
                                <div className='col-xl-1 fw-bold fs-6 text-left'>KDV'li</div>
                                <div className='col-xl-3 offset-xl-2 fw-bold fs-6 text-left'>
                                  Aktarım Hedefi
                                </div>
                                <div className='col-xl-1 fw-bold fs-6 text-left'>
                                  Aktarım Tutarı
                                </div>
                                <div className='col-xl-1'></div>
                              </div>
                              {price?.serviceProviderShares?.map((m, i) => {
                                return (
                                  <div className='row mb-2' key={i}>
                                    <div className='col-xl-3'>
                                      <select
                                        className='form-select form-select-solid'
                                        value={
                                          (m.serviceProviderRoleId ?? 0) === MALI_MUSAVIR_ROLE_ID
                                            ? MALI_MUSAVIR_OPTION_VALUE
                                            : m.serviceProviderId ?? 0
                                        }
                                        onChange={(event) => {
                                          const value = parseInt(event.target.value)
                                          const sharePath = `prices.${index}.serviceProviderShares.${i}`
                                          if (value === MALI_MUSAVIR_OPTION_VALUE) {
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProviderRoleId`,
                                              MALI_MUSAVIR_ROLE_ID
                                            )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProviderRole`,
                                              'Mali Müşavir'
                                            )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProviderId`,
                                              0
                                            )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProvider`,
                                              ''
                                            )
                                          } else {
                                            const sp =
                                              adminState.productsPage?.serviceProviders?.find(
                                                (s) => s.id === value
                                              )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProviderId`,
                                              value
                                            )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProvider`,
                                              sp?.description ?? ''
                                            )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProviderRoleId`,
                                              0
                                            )
                                            form_props.setFieldValue(
                                              `${sharePath}.serviceProviderRole`,
                                              ''
                                            )
                                          }
                                        }}
                                      >
                                        <option value={0}>Servis Sağlayıcı Seçiniz</option>
                                        {adminState.productsPage?.serviceProviders?.map((sp) => (
                                          <option key={sp.id} value={sp.id ?? 0}>
                                            {sp.description}
                                          </option>
                                        ))}
                                        <option
                                          value={MALI_MUSAVIR_OPTION_VALUE}
                                          style={{color: '#009ef7', fontWeight: 'bold'}}
                                        >
                                          Mali Müşavir
                                        </option>
                                      </select>
                                    </div>
                                    <div className='col-xl-1'>
                                      <FormInput
                                        fieldAttributes={{
                                          type: 'number',
                                          name: `prices.${index}.serviceProviderShares.${i}.totalPriceWithoutTax`,
                                          placeholder: '',
                                          className: 'text-end',
                                          onChange: (event: any) => {
                                            const value = parseFloat(
                                              event.target.value == '' ? 0 : event.target.value
                                            )
                                            form_props.setFieldValue(
                                              `prices.${index}.serviceProviderShares.${i}.totalPriceWithoutTax`,
                                              value
                                            )

                                            form_props.setFieldValue(
                                              `prices.${index}.serviceProviderShares.${i}.totalPrice`,
                                              value * 1.2
                                            )
                                          },
                                        }}
                                        istouched={true}
                                        errorMessage={undefined}
                                        placeHolderOnTop={false}
                                        checkValid={false}
                                      />
                                    </div>
                                    <div className='col-xl-1'>
                                      <FormInput
                                        fieldAttributes={{
                                          type: 'number',
                                          name: `prices.${index}.serviceProviderShares.${i}.totalPrice`,
                                          placeholder: '',
                                          className: 'text-end',
                                          onChange: (event: any) => {
                                            const value = parseFloat(
                                              event.target.value == '' ? 0 : event.target.value
                                            )
                                            form_props.setFieldValue(
                                              `prices.${index}.serviceProviderShares.${i}.totalPrice`,
                                              value
                                            )

                                            // form_props.setFieldValue(
                                            //   `prices.${index}.shares.${i}.totalPriceWithoutTax`,
                                            //   value / 1.2
                                            // )
                                          },
                                        }}
                                        istouched={true}
                                        errorMessage={undefined}
                                        placeHolderOnTop={false}
                                        checkValid={false}
                                      />
                                    </div>
                                    <div className='col-xl-3 offset-xl-2'>
                                      <CustomDropdown
                                        fieldAttributes={{
                                          name: `prices.${index}.serviceProviderShares.${i}.payoutTargetServiceProviderId`,
                                          placeholder: 'AKTARIM_HEDEFI',
                                        }}
                                        noSelectionText='AKTARIM_HEDEFI_SECINIZ'
                                        options={
                                          adminState.productsPage?.serviceProviders?.map((sp) => {
                                            const v: DropdownOption = {
                                              label: sp.description ?? '',
                                              value: sp.id ?? 0,
                                            }
                                            return v
                                          }) ?? []
                                        }
                                        noSelectionValue={0}
                                        placeHolderOnTop={false}
                                        setFieldValue={form_props.setFieldValue}
                                        valueConverter={parseInt}
                                      />
                                    </div>
                                    <div className='col-xl-1'>
                                      <FormInput
                                        fieldAttributes={{
                                          type: 'number',
                                          name: `prices.${index}.serviceProviderShares.${i}.payoutAmount`,
                                          placeholder: '',
                                          className: 'text-end',
                                          onChange: (event: any) => {
                                            const value = parseFloat(
                                              event.target.value == '' ? 0 : event.target.value
                                            )
                                            form_props.setFieldValue(
                                              `prices.${index}.serviceProviderShares.${i}.payoutAmount`,
                                              value
                                            )
                                          },
                                        }}
                                        istouched={true}
                                        errorMessage={undefined}
                                        placeHolderOnTop={false}
                                        checkValid={false}
                                      />
                                    </div>
                                    <div className='col-xl-1 d-flex align-items-center justify-content-end'>
                                      {(price.serviceProviderShares?.length ?? 0) > 1 && (
                                        <button
                                          type='button'
                                          className='btn btn-xs btn-icon btn-color-danger btn-active-light-danger w-20px h-20px'
                                          onClick={() => {
                                            const currentShares =
                                              form_props.values.prices?.[index]?.serviceProviderShares ?? []
                                            form_props.setFieldValue(
                                              `prices.${index}.serviceProviderShares`,
                                              currentShares.filter((_, idx) => idx !== i)
                                            )
                                          }}
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/abstract/abs012.svg'
                                            className='svg-icon-muted svg-icon-3'
                                          />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )
                              })}

                              <div className='row'>
                                <div className='col-xl-3 fs-6 text-left d-flex align-items-center'>
                                  <div>Toplam</div>
                                </div>
                                <div className='col-xl-1'>
                                  <input
                                    type='number'
                                    disabled
                                    className='form-control form-control-solid text-end'
                                    value={_.sumBy(
                                      form_props.values.prices?.at(index)?.serviceProviderShares,
                                      (s) => s.totalPriceWithoutTax ?? 0
                                    ).toFixed(2)}
                                  />
                                </div>
                                <div className='col-xl-1'>
                                  <input
                                    type='number'
                                    disabled
                                    className='form-control form-control-solid text-end'
                                    value={_.sumBy(
                                      form_props.values.prices?.at(index)?.serviceProviderShares,
                                      (s) => s.totalPrice ?? 0
                                    ).toFixed(2)}
                                  />
                                </div>
                                <div className='col-xl-3 offset-xl-2 fs-6 text-left py-3'></div>
                                <div className='col-xl-2 fs-6 text-end'>
                                  <button
                                    type='button'
                                    className='btn btn-primary btn-sm'
                                    onClick={() => {
                                      const currentShares =
                                        form_props.values.prices?.[index]?.serviceProviderShares ??
                                        []
                                      form_props.setFieldValue(
                                        `prices.${index}.serviceProviderShares`,
                                        [...currentShares, createEmptyShare()]
                                      )
                                    }}
                                  >
                                    Yeni Fiyat Ekle
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className='row'>
                        <div className='col-xl-12'>
                          <div className='row'>
                            <div className='col-xl-3 offset-3'>
                              <CustomDropdown
                                fieldAttributes={{
                                  name: `temp_service_provider_id`,
                                  placeholder: 'SERVIS_SAGLAYICI_SECINIZ',
                                  onChange: (event: any) => {
                                    setSelectedServiceProviderId(parseInt(event.target.value))
                                  },
                                }}
                                noSelectionText='SERVIS_SAGLAYICI_SECINIZ'
                                options={
                                  adminState.productsPage?.serviceProviders?.map((m) => {
                                    const v: DropdownOption = {
                                      label: m.description ?? '',
                                      value: m.id ?? 0,
                                    }
                                    return v
                                  }) ?? []
                                }
                                noSelectionValue={0}
                                placeHolderOnTop={false}
                                setFieldValue={form_props.setFieldValue}
                                valueConverter={parseInt}
                              />
                            </div>
                            <div className='col-xl-3'>
                              <div
                                onClick={() => {
                                  const newPrice =
                                    generatePriceForServiceProvider(selectedServiceProviderId)
                                  defterdar_log(newPrice)
                                  arrayHelpers.push(newPrice)
                                }}
                                className='btn btn-lg btn-primary me-3'
                              >
                                Özel Fiyat Ekle +
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                />
              </div>
            </div>

            <div className='row mt-5'>
              <div className='col-xl-4 offset-xl-4'>
                <FormMessage {...form_props.status} />
              </div>
            </div>
          </>
        )
      }}
    </FormikForm>
  )
}

export default AdminProductPricesForm
